var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('label',{staticClass:"label label--spaced",attrs:{"for":"keywords"}},[_vm._v("Search terms:")]),_c('query-input',{attrs:{"id":"keywords","class-name":"input"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }